import React, { useEffect, useState } from 'react'
import {
  DEMO_CAMPAIGN_ENABLED,
  DEMO_ENABLED_EVENT,
  clearDemoMode,
  isDemoMode,
} from '../utils/demoMode'
import { clearDemoStore } from '../utils/demoStore'

/**
 * Persistent banner while campaign demo mode is active.
 * Adds `demo-mode-active` to <body> so the fixed site header shifts below it
 * (see index.css) instead of being covered by the banner.
 */
const DemoBanner = () => {
  const [visible, setVisible] = useState(() => DEMO_CAMPAIGN_ENABLED && isDemoMode())

  useEffect(() => {
    const sync = () => setVisible(DEMO_CAMPAIGN_ENABLED && isDemoMode())
    window.addEventListener(DEMO_ENABLED_EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(DEMO_ENABLED_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  useEffect(() => {
    document.body.classList.toggle('demo-mode-active', visible)
    return () => document.body.classList.remove('demo-mode-active')
  }, [visible])

  if (!visible) return null

  const exitDemo = () => {
    clearDemoStore()
    clearDemoMode()
    setVisible(false)
    window.location.href = '/'
  }

  return (
    <div className="demo-banner fixed top-0 left-0 right-0 z-[10000] bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-amber-950 shadow-md">
      <div className="mx-auto flex h-10 max-w-7xl items-center justify-center gap-2 px-3 sm:gap-3 sm:px-6">
        <span className="hidden shrink-0 items-center gap-1.5 rounded-full bg-amber-950/15 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider sm:inline-flex">
          <i className="fas fa-flask text-[10px]" aria-hidden="true"></i>
          Demo
        </span>

        <p className="truncate text-xs font-medium sm:text-sm">
          <span className="sm:hidden">Demo mode — nothing is saved.</span>
          <span className="hidden sm:inline">
            You are exploring in demo mode — book, favorite and pay freely.
          </span>
        </p>

        <button
          type="button"
          onClick={exitDemo}
          className="shrink-0 rounded-full bg-amber-950/90 px-3 py-1 text-[11px] font-semibold text-amber-50 transition-colors hover:bg-amber-950 sm:text-xs"
        >
          Exit demo
        </button>
      </div>
    </div>
  )
}

export default DemoBanner
